import React from 'react';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import { CustomizerItemWrapper } from '../index.style';
import {
  sidebarBgImages,
  sidebarColors,
} from '../../../services/db/navigationStyle';
import {
  useSidebarActionsContext,
  useSidebarContext,
} from '../../../utility/AppContextProvider/SidebarContextProvider';
import CheckIcon from '@mui/icons-material/Check';
import NavMenuStyle from './NavMenuStyle';
import MenuColorCell from './MenuColorCell';
import AppGrid from '../../AppGrid';
import { ButtonContained } from 'shared/components/Button';
import { onPutSidebarSetting } from 'redux/actions/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import AppLoader from '@crema/core/AppLoader';
import AppInfoView from '@crema/core/AppInfoView';
import HeaderMenuStyle from './HeaderMenuStyle';
import AppScrollbar from '@crema/core/AppScrollbar';
const SidebarSettings = () => {
  const dispatch = useDispatch();
  const { sidebarBgImage, isSidebarBgImage, sideBarData } = useSidebarContext();

  const { updateSidebarBgImage, setSidebarBgImage, setSideBarData } = useSidebarActionsContext();

  const onToggleSidebarImage = () => {
    setSidebarBgImage(!isSidebarBgImage);
    setSideBarData((data) => { return { ...data, isSidebarBgImage: !isSidebarBgImage } });
  };

  const onClickImage = (imagesObj) => {
    updateSidebarBgImage(imagesObj.id);
    setSideBarData((data) => { return { ...data, sidebarBgImage: imagesObj.id } });
  };

  const handleSave = () => {
    let postData = JSON.stringify({ key: "sidebar_settings", value: JSON.stringify(sideBarData) });
    dispatch(onPutSidebarSetting(postData));
  };
  const { loading } = useSelector(state => state.common);

  if (loading) return (
    <>
      <AppInfoView />
      <AppLoader />
    </>
  )
  else
    return (
      <CustomizerItemWrapper>
        <Box
          sx={{
            padding: { xs: '20px', xl: '28px 22px' },
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box component='h3' mb={0.5} fontSize={18}>
            Pengaturan
          </Box>
        </Box>

        <Box
          sx={{
            width: { xs: 300, md: 360, xl: 400 },
            flex: 1,
            padding: { xs: '20px', xl: '28px 22px' },
          }}
        >
          <HeaderMenuStyle />
          <NavMenuStyle />
        </Box>

        <Box
          sx={{
            padding: { xs: '20px', xl: '28px 22px' },
          }}
        >
          <ButtonContained sx={{ mt: 2, width: '100%' }} variant='contained' onClick={() => handleSave()}>Simpan Pengaturan</ButtonContained>
          <AppInfoView />
        </Box>
      </CustomizerItemWrapper>
    );
};

export default SidebarSettings;
